export default __webpack_public_path__ + "static/media/fotosalo3.094e681e.png";